<template>
	<div class="file-viewer-src-input" v-if="fileViewer.active">
		<CombinedInputFieldDataMenu
			readonly
			:textAreaMode="false"
			:value.sync="fileViewerSrc"
			:attachTo="'.file-viewer-src-input'"
			placeholder="Choose file to preview"
			:valuesTypes="dataInputMenuValueTypes"
			:hasDelete="true"
		/>
	</div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import CombinedInputFieldDataMenu from '@/components/DataInput/CombinedInputFieldDataMenu';
import ItemOnlyAllowedValueTypesMixin from '../ValueTypesMixins/ItemOnlyAllowedValueTypesMixin';

export default {
	name: 'FileViewerSettings',
	mixins: [ItemOnlyAllowedValueTypesMixin],
	components: {
		CombinedInputFieldDataMenu,
	},
	computed: {
		...mapGetters('widgetEditor', ['widgetMetadata']),
		fileViewer() {
			return this.widgetMetadata.options.file_viewer || {};
		},
		fileViewerSrc: {
			get() {
				return this.fileViewer.value || '';
			},
			set(value) {
				this.setWidgetOption({ key: 'file_viewer', value: { value, active: true } });
			},
		},
	},
	methods: {
		...mapActions('widgetEditor', ['setWidgetOption']),
	},
};
</script>

<style scoped lang="scss"></style>
